const addObservator = (dataAttribute: string, animationFunction: CallableFunction, className?: string): void => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animationFunction(entry, className)
        }
      })
    },
    {
      threshold: 0.3,
    },
  )

  const $landingAttributes = document.querySelectorAll<HTMLElement>(dataAttribute)
  $landingAttributes.forEach((el) => {
    observer.observe(el)
  })
}

const customAnimation = (entry: IntersectionObserverEntry): void => {
  const classNameString = entry.target.getAttribute('data-animation-custom')
  entry.target.classList.add(classNameString)
}

const addClassToElement = (entry: IntersectionObserverEntry, className: string): void => {
  entry.target.classList.add(className)
}

export const initCurrencyLandingsAnimations = (): void => {
  addObservator('[data-animation-award]', addClassToElement, 'animation-award')
  addObservator('[data-animation-fade-in]', addClassToElement, 'animation-fadeIn')
  addObservator('[data-animation-jump-in]', addClassToElement, 'animation-jumpIn')
  addObservator('[data-animation-slide-in]', addClassToElement, 'animation-slideIn')
  addObservator('[data-animation-custom]', customAnimation)
}
